<template>
  <component
    :is="info.tag"
    class="mt-12 mb-16"
    :class="{ 'body-2 list-none': info.tag === 'ul' }"
  >
    <component
      :is="info.subTag"
      v-for="text in info.text"
      :key="text"
      class="flex gap-12"
    >
      <IconCheckSmall
        v-if="info.text && info.text.length > 1"
        class="shrink-0"
      />
      {{ text }}
    </component>
  </component>
</template>

<script setup lang="ts">
import { IconCheckSmall } from '@ds/icons/IconCheckSmall'

import type { Info } from '~/scopes/buyback/composables/useFunnelQuestions'

defineProps<{
  info: Info
}>()
</script>
